import PropTypes from 'prop-types';

import moment from 'moment';

import Box from '@mui/joy/Box';

import { useBaseRoute, useFeatureFlag, useManagerUser, useUser } from '@/hooks';

import Sidebar from '@/components/Sidebar';
import { Books, CardsThree, ChartLineUp, Gear, Megaphone, Waveform } from '@phosphor-icons/react';

import { createTeleporter } from 'react-teleporter';

import { User } from '@phosphor-icons/react';

import i18n from '@/i18n';
import { SquaresFour, ChartBar, Smiley } from '@phosphor-icons/react';
import { Outlet } from 'react-router-dom';
import { AppHeader } from '@/components/AppHeader';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '@/actions/login';
import { useSessionContext } from '@/contexts/SessionContext';
import { useManager } from '@/hooks';
import { useLocation } from 'react-router-dom';
import { useIsAdminRoute, useResource } from '@/hooks';

import { Avatar, Container } from '@mui/joy';
import { BottomTabBar, BottomTabBarTabLink } from '@/components/BottomTabBar';
import RecordLabel from '@/components/RecordLabel';
import { FeatureCard } from '@/components/FeatureCard';
import { Link } from 'react-router-dom';

export const TitleBar = createTeleporter()

export function DashboardLayout({ children }) {

  const navigate = useNavigate()
  const location = useLocation()

  const user = useUser()

  const { managerUser } = useManagerUser()

  const manager = useManager()

  const { setUser } = useSessionContext()
  
  const hasDiscoveryMode = useFeatureFlag('discoveryMode')
  console.log("children", children)

  const { data: docs } = useResource({
    queryKey: ['docs'],
    path: `/docs`
  })

  const { data: discoveryModeRecordings } = useResource({
    queryKey: [manager?.type, manager?.id, 'discovery-mode-campaign', 'upcoming', 'recordings'],
    path: `/${manager?.type}/${manager?.id}/discovery-mode-campaign/upcoming/recordings`
  })

  console.log("discoveryModeRecordings", discoveryModeRecordings)

  let menuItems = []

  useEffect(() => {
    getCurrentUser().then((data) => {
      if (data) {
        if (!data.code) {
          setUser(data)
        } else {
          navigate(`/accounts/login`)
        }
      }
    }).catch(e => {
      console.error(e)
      //navigate(`/accounts/login`)
    })
  }, [])

  const handleFavIcon = () => {
    if (manager && manager.is_branded) {
      if (manager.favicon_url) {
        let link = document.querySelector("link[rel~='icon']");
        if (link) {
          link.parentNode.removeChild(link)
          link = null
        }
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
        link.href = manager.favicon_url;
      }
      if (manager.name) {
        let titleEl = document.querySelector("title");
        if (!titleEl) {
          titleEl = document.createElement('title');
          document.getElementsByTagName('head')[0].appendChild(titleEl);
        }
        titleEl.innerHTML = manager.name
      }
    }
  }

  useEffect(handleFavIcon, [location])
  useEffect(handleFavIcon, [manager])
  
  console.log("managerUser", managerUser)

  if (manager) {
    menuItems = [
      { 
        "id": "dashboard",
        "href": "/overview",
        "Icon": SquaresFour,
        "text": i18n.t("dashboard"),
        "helpText": "Dashboard"
      },
      {
        "id": "statistics",
        "Icon": ChartBar,
        "href": "/statistics",
        "text": i18n.t("statistics"),
        "query": {
          "start": moment().subtract(28, 'days').format('YYYY-MM-DD'),
          "end": moment().format('YYYY-MM-DD'),
        }
      },
      (manager?.type !== 'artist') ? {
        "id": "artists",
        "href": "/artists",
        "text": i18n.t('artists'),
        "Icon": Smiley
      } : null,
      {
        "id": "releases",
        "href": "/releases",
        "text": i18n.t('releases'),
        "Icon": CardsThree
      },
      {
        "id": "recordings",
        "href": "/recordings",
        "text": i18n.t('tracks'),
        "Icon": Waveform
      },
      {
        "id": "guides",
        "text": i18n.t('guides'),
        "Icon": Books,
        "href": "/guides",
        "items": /*docs?.results?.length > 0 ? (
          docs?.results?.map(doc => ({
            id: doc.id,
            text: doc.name,
            icon: Books,
            href: `/guides/${doc.id}`
          }))
        ) :*/ []
      },
      ...(['owner', 'admin'].indexOf(managerUser?.role) !== -1 ? ([
        (manager?.type !== 'artist') ? {
          "id": "labels",
          "text": i18n.t('labels'),
          "href": `/labels`,
          "Icon": RecordLabel
        } : null,
        {
          "id": "edit",
          "text": i18n.t('settings'),
          "href": "/edit",
          "Icon": Gear
        },
        {
          "id": "people",
          "text": i18n.t('people'),
          "href": "/people",
          "icon": Smiley
        },
        {
          "id": "payees",
          "text": i18n.t('payees'),
          "href": "/payees",
          "icon": User
        },
        (manager?.type !== 'artist') ? ({
          "id": "users",
          "text": i18n.t('users'),
          "href": "/users",
          "icon": User
        }) : null
      ]) : []),
    ]
  }

  const isAdminRoute = useIsAdminRoute()

  const BASE_URL = useBaseRoute()

  return (
    <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'stretch' }}>
      <Box sx={{ display: 'flex', flex: 1 }}>
        <Sidebar menuItems={menuItems} />
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            height: '100dvh',
            overflow: 'auto',
          }}
        >
          {!isAdminRoute && <AppHeader user={user} />}
          <Box sx={{ overflow: '', '@media screen and (max-width: 728pt)': { overflow: 'auto' }, flex: 1 }}>
            {hasDiscoveryMode && discoveryModeRecordings?.results?.length > 0 && (
              <Container>
                <br />
                <FeatureCard
                  sx={{ marginBottom: 1, p: 1 }}
                  as={Link}
                  name={i18n.t('dm-eligibility.name')}
                  description={i18n.t('dm-eligibility.description')}              
                  Icon={Megaphone}
                  to={`/${manager?.type}/${manager?.id}/marketing/discovery-mode`}
                />
              </Container>
            )}
            <Outlet />
          </Box>
          <BottomTabBar> 
            <BottomTabBarTabLink to={`${BASE_URL}/overview`} icon={SquaresFour}>{i18n.t('dashboard')}</BottomTabBarTabLink>
            <BottomTabBarTabLink to={`${BASE_URL}/statistics`} icon={ChartLineUp}>{i18n.t('statistics')}</BottomTabBarTabLink>
            <BottomTabBarTabLink to={`${BASE_URL}/user/${user?.id}`} icon={() => <Avatar src={user?.image_url} />}>{i18n.t('account')}</BottomTabBarTabLink>
          </BottomTabBar>
        </Box>
      </Box>
    </Box>
  )
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired
}

export default DashboardLayout;